import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card card-default custom-card-height" }
const _hoisted_3 = { class: "card-header feature-header" }
const _hoisted_4 = { class: "row g-2" }
const _hoisted_5 = { class: "col-auto me-auto" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = { class: "unified-daterangepicker form-group mb-0" }
const _hoisted_9 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_10 = { class: "dropdown-container" }
const _hoisted_11 = { value: "" }
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 1,
  class: "col-auto"
}
const _hoisted_14 = {
  key: 0,
  class: "form-group mb-0"
}
const _hoisted_15 = {
  key: 2,
  class: "col-auto"
}
const _hoisted_16 = { class: "form-group mb-0" }
const _hoisted_17 = {
  class: "col-auto mt-3",
  "\"": ""
}
const _hoisted_18 = { class: "col-auto" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "card-body card-body-custom-layout" }
const _hoisted_21 = { class: "card-body-grid" }
const _hoisted_22 = {
  key: 0,
  class: "badge badge-sm text-bg-info"
}
const _hoisted_23 = {
  key: 1,
  class: "badge badge-sm text-bg-dark"
}
const _hoisted_24 = {
  key: 2,
  class: "badge badge-sm text-bg-success"
}
const _hoisted_25 = {
  key: 3,
  class: "badge badge-sm text-bg-danger"
}
const _hoisted_26 = {
  key: 4,
  class: "badge badge-sm text-bg-warning"
}
const _hoisted_27 = {
  key: 5,
  class: "badge badge-sm text-bg-danger"
}
const _hoisted_28 = { key: 6 }
const _hoisted_29 = ["title"]
const _hoisted_30 = {
  key: 0,
  class: "badge badge-sm text-bg-success"
}
const _hoisted_31 = {
  key: 1,
  class: "badge badge-sm text-bg-success"
}
const _hoisted_32 = { key: 2 }
const _hoisted_33 = {
  key: 0,
  class: "badge badge-sm text-bg-success"
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "job-run-cell" }
const _hoisted_36 = ["title", "onClick"]
const _hoisted_37 = {
  class: "btn-group actions-row",
  role: "group",
  "aria-label": "Row actions"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  class: "modal fade",
  id: "requestedModal",
  role: "dialog"
}
const _hoisted_40 = { class: "modal-dialog modal-xl" }
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = { class: "modal-header" }
const _hoisted_43 = { class: "modal-title" }
const _hoisted_44 = { class: "modal-body p-2" }
const _hoisted_45 = { class: "property-value-grid sync-log-details-grid" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = ["title"]
const _hoisted_48 = ["title"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "modal-footer" }
const _hoisted_52 = {
  class: "modal fade",
  id: "jobRunStatusModal",
  role: "dialog"
}
const _hoisted_53 = { class: "modal-dialog modal-lg" }
const _hoisted_54 = { class: "modal-content" }
const _hoisted_55 = { class: "modal-header" }
const _hoisted_56 = { class: "modal-title" }
const _hoisted_57 = { class: "modal-body" }
const _hoisted_58 = { class: "card-body" }
const _hoisted_59 = { class: "row mb-2" }
const _hoisted_60 = { class: "col-md-4 fw-bold text-secondary" }
const _hoisted_61 = { class: "col-md-8" }
const _hoisted_62 = { class: "row mb-2" }
const _hoisted_63 = { class: "col-md-4 fw-bold text-secondary" }
const _hoisted_64 = { class: "col-md-8" }
const _hoisted_65 = { class: "row mb-2" }
const _hoisted_66 = { class: "col-md-4 fw-bold text-secondary" }
const _hoisted_67 = { class: "col-md-8 text-success" }
const _hoisted_68 = { class: "row mb-2" }
const _hoisted_69 = { class: "col-md-4 fw-bold text-secondary" }
const _hoisted_70 = { class: "col-md-8" }
const _hoisted_71 = { class: "row mb-2" }
const _hoisted_72 = { class: "col-md-4 fw-bold text-secondary" }
const _hoisted_73 = { class: "col-md-8" }
const _hoisted_74 = { class: "row mb-2" }
const _hoisted_75 = { class: "col-md-4 fw-bold text-secondary" }
const _hoisted_76 = { class: "col-md-8" }
const _hoisted_77 = { class: "row mb-2" }
const _hoisted_78 = { class: "col-md-4 fw-bold text-secondary" }
const _hoisted_79 = { class: "col-md-8" }
const _hoisted_80 = { class: "badge bg-secondary" }
const _hoisted_81 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTitleComponent = _resolveComponent("CardTitleComponent")!
  const _component_SearchComponent = _resolveComponent("SearchComponent")!
  const _component_ejs_daterangepicker = _resolveComponent("ejs-daterangepicker")!
  const _component_ejs_dropdownlist = _resolveComponent("ejs-dropdownlist")!
  const _component_ejs_checkbox = _resolveComponent("ejs-checkbox")!
  const _component_e_column = _resolveComponent("e-column")!
  const _component_e_columns = _resolveComponent("e-columns")!
  const _component_ejs_grid = _resolveComponent("ejs-grid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_CardTitleComponent)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_SearchComponent, {
                modelValue: _ctx.searchText,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                onSearch: _ctx.onSearch,
                onClear: _ctx.clearSearch
              }, null, 8, ["modelValue", "onSearch", "onClear"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_ejs_daterangepicker, {
                  id: "syncLogDateRange",
                  zIndex: 10000,
                  change: _ctx.onchangeDateRange,
                  format: "yyyy-MM-dd",
                  startDate: _ctx.manageFilter.startDate,
                  endDate: _ctx.manageFilter.endDate,
                  placeholder: _ctx.$t('selectRange'),
                  firstDayOfWeek: 1
                }, null, 8, ["change", "startDate", "endDate", "placeholder"])
              ])
            ]),
            (_ctx.userStore.userInfo.isHost)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("select", {
                      class: "dropdown-select",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.subscriptionId) = $event)),
                      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubscriptionChanged && _ctx.onSubscriptionChanged(...args)))
                    }, [
                      _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t('selectCustomer')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptionList, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.id,
                          value: item.id
                        }, _toDisplayString(item.organizationName), 9, _hoisted_12))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.subscriptionId]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.userStore.userInfo.isHost || Boolean(_ctx.subscriptionId))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_ctx.moduleList?.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_ejs_dropdownlist, {
                          id: "moduleList",
                          ref: "moduleList",
                          "popup-width": 'auto',
                          modelValue: _ctx.moduleId,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.moduleId) = $event)),
                          dataSource: _ctx.moduleList.map((m) => ({ id: m.id, text: m.displayName })),
                          placeholder: _ctx.$t('select') + ' ' + _ctx.$t('module'),
                          showClearButton: false,
                          fields: { text: 'text', value: 'id' },
                          onChange: _ctx.changeModule
                        }, null, 8, ["modelValue", "dataSource", "placeholder", "onChange"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.moduleId && _ctx.companies?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_ejs_dropdownlist, {
                      id: "companyList",
                      ref: "companyList",
                      "popup-width": 'auto',
                      modelValue: _ctx.companyId,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyId) = $event)),
                      dataSource: _ctx.companies.map((c) => ({ id: c.id, text: c.name })),
                      placeholder: _ctx.$t('select') + ' ' + _ctx.$t('company'),
                      showClearButton: false,
                      fields: { text: 'text', value: 'id' },
                      onChange: _ctx.onCompanyChange
                    }, null, 8, ["modelValue", "dataSource", "placeholder", "onChange"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_ejs_checkbox, {
                label: "Show Pending",
                modelValue: _ctx.includePending,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.includePending) = $event)),
                onChange: _ctx.onFilterChange
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary",
                disabled: !(_ctx.moduleId > 0),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dataStateChange(
              _ctx.initState(_ctx.pageSettings.skip, _ctx.pageSettings.take)
            )))
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-sync-alt me-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('refresh')), 1)
              ], 8, _hoisted_19)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_ejs_grid, {
              ref: "gridSyncLog",
              dataSource: _ctx.data,
              allowPaging: true,
              allowResizing: true,
              pageSettings: _ctx.pageSettings,
              locale: _ctx.locale,
              rowHeight: 38,
              height: "100%",
              allowSorting: true,
              searchSettings: _ctx.searchOptions,
              dataStateChange: _ctx.dataStateChange,
              commandClick: _ctx.commandClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_e_columns, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_e_column, {
                      headerText: _ctx.isFinanceModule() ? _ctx.$t('legalEntity') : _ctx.$t('companyName'),
                      field: "CompanyName",
                      "allow-sorting": false,
                      width: "200",
                      freeze: "Left"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('runStatus'),
                      field: "RunStatusId",
                      textAlign: "Center",
                      width: "150",
                      template: 'RunStatusTemplate'
                    }, {
                      RunStatusTemplate: _withCtx(({ data }) => [
                        (data.statusId === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('pending')), 1))
                          : (data.statusId === 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('running')), 1))
                            : (data.statusId === 3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('success')), 1))
                              : (data.statusId === 4)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('errors')), 1))
                                : (data.statusId === 5)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('warnings')), 1))
                                  : (data.statusId === 6)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('forcefullyTerminated')), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                        _createElementVNode("a", {
                                          href: "#",
                                          "data-bs-toggle": "tooltip",
                                          title: _ctx.getHoverMessage(data.runStatusId, data.hasError)
                      
                                        }, [
                                          _createElementVNode("i", {
                                            class: _normalizeClass(_ctx.getRunStatusIcon(data.runStatusId, data.hasError)
                        )
                                          }, null, 2)
                                        ], 8, _hoisted_29)
                                      ]))
                      ]),
                      _: 1
                    }, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('requestedAt'),
                      field: "RequestedAt",
                      type: "date",
                      format: "yyyy-MM-dd hh:mm a"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('requestedBy'),
                      field: "RequestedBy",
                      template: 'requestedByTemplate'
                    }, {
                      requestedByTemplate: _withCtx(({ data }) => [
                        (data.requestedBy == 'FortnoxAPI')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(data.requestedBy), 1))
                          : _createCommentVNode("", true),
                        (data.requestedBy == 'NetVisorAPI')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(data.requestedBy), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_32))
                      ]),
                      _: 1
                    }, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('startedAt'),
                      field: "StartedAt",
                      type: "date",
                      format: "yyyy-MM-dd hh:mm a"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('completedAt'),
                      field: "CompletedAt",
                      type: "date",
                      format: "yyyy-MM-dd hh:mm a"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('errorMessage'),
                      field: "ErrorMessage",
                      width: "350"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('isFullSync'),
                      field: "IsFullSync",
                      textAlign: "Center",
                      width: "100",
                      template: 'IsFullSyncTemplate'
                    }, {
                      IsFullSyncTemplate: _withCtx(({ data }) => [
                        (data.isFullSync)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t('yes')), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_34))
                      ]),
                      _: 1
                    }, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('jobRunId'),
                      field: "JobRunId",
                      template: 'JobRunIdTemplate'
                    }, {
                      JobRunIdTemplate: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_35, [
                          (data.jobRunId)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "javascript:void(0)",
                                class: "me-2 action-link job-run-action",
                                title: _ctx.$t('jobRunStatus'),
                                onClick: ($event: any) => (_ctx.getJobRunStatus(data.jobRunId))
                              }, [...(_cache[12] || (_cache[12] = [
                                _createElementVNode("i", {
                                  class: "e-eye e-icons",
                                  style: {"font-size":"0.76em"}
                                }, null, -1)
                              ]))], 8, _hoisted_36))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(data.jobRunId), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('tryCount'),
                      field: "TryCount",
                      width: "100",
                      textAlign: "Center"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: 'Force Sync Date',
                      field: "forceSyncDate",
                      format: "yyyy-MM-dd hh:mm a"
                    }),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('actions'),
                      textAlign: "Center",
                      freeze: "Right",
                      width: "100",
                      template: 'actionTemplate'
                    }, {
                      actionTemplate: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "ms-2 action-link",
                            title: "View Details",
                            onClick: ($event: any) => (_ctx.actionColumnClick( data))
                          }, [...(_cache[13] || (_cache[13] = [
                            _createElementVNode("i", {
                              class: "e-eye e-icons",
                              style: {"font-size":"0.76em"}
                            }, null, -1)
                          ]))], 8, _hoisted_38)
                        ])
                      ]),
                      _: 1
                    }, 8, ["headerText"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["dataSource", "pageSettings", "locale", "searchSettings", "dataStateChange", "commandClick"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("h4", _hoisted_43, _toDisplayString(_ctx.$t('syncLogDetails')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.close(_ctx.modalType.requestedModal)))
            }, [...(_cache[14] || (_cache[14] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_ejs_grid, {
                ref: "gridSyncLogDetails",
                dataSource: _ctx.details.data,
                toolbar: _ctx.details.toolbar,
                allowPaging: true,
                allowResizing: true,
                pageSettings: _ctx.details.pageSettings,
                locale: _ctx.locale,
                rowHeight: 30,
                allowSorting: true,
                searchSettings: _ctx.details.searchOptions,
                dataStateChange: _ctx.dataStateChangeDetails
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_e_columns, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_e_column, {
                        headerText: _ctx.$t('entity'),
                        field: "Entity"
                      }, null, 8, ["headerText"]),
                      _createVNode(_component_e_column, {
                        visible: _ctx.moduleList.filter((x) => x.id == _ctx.moduleId)[0]?.name ==
                    _ctx.moduleEnumData.Finance.id,
                        headerText: _ctx.$t('sourceSystem'),
                        field: "sourceSystem"
                      }, null, 8, ["visible", "headerText"]),
                      _createVNode(_component_e_column, {
                        headerText: _ctx.$t('runStatus'),
                        field: "RunStatusId",
                        width: "130",
                        textAlign: "Center",
                        template: 'RunStatusTemplate'
                      }, {
                        RunStatusTemplate: _withCtx(({ data }) => [
                          data
                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                                _createElementVNode("a", {
                                  href: "#",
                                  "data-bs-toggle": "tooltip",
                                  title: _ctx.getHoverMessage(data.runStatusId, data.hasError)
                          
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_ctx.getRunStatusIcon(data.runStatusId, data.hasError)
                            )
                                  }, null, 2)
                                ], 8, _hoisted_47)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["headerText"]),
                      _createVNode(_component_e_column, {
                        headerText: _ctx.$t('errorMessage'),
                        field: "ErrorMessage",
                        width: "465",
                        template: 'ErrorMessageTemplate'
                      }, {
                        ErrorMessageTemplate: _withCtx(({ data }) => [
                          (data.errorMessage && data.errorMessage.length > 0)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "copy-icon",
                                href: "#",
                                "data-bs-toggle": "tooltip",
                                title: _ctx.$t('copy')
                              }, [
                                _createElementVNode("i", {
                                  class: "fas fa-copy",
                                  onClick: ($event: any) => (_ctx.copyToClipboard(data.errorMessage))
                                }, null, 8, _hoisted_49)
                              ], 8, _hoisted_48))
                            : _createCommentVNode("", true),
                          (data.errorMessage)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(data.errorMessage), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["headerText"]),
                      _createVNode(_component_e_column, {
                        headerText: _ctx.$t('startedAt'),
                        field: "StartedAt",
                        type: "date",
                        width: "155",
                        format: "yyyy-MM-dd hh:mm a"
                      }, null, 8, ["headerText"]),
                      _createVNode(_component_e_column, {
                        headerText: _ctx.$t('completedAt'),
                        field: "CompletedAt",
                        width: "155",
                        type: "date",
                        format: "yyyy-MM-dd hh:mm a"
                      }, null, 8, ["headerText"]),
                      _createVNode(_component_e_column, {
                        headerText: _ctx.$t('syncFromDate'),
                        field: "syncFromDate",
                        width: "155",
                        type: "date",
                        format: "yyyy-MM-dd hh:mm a"
                      }, null, 8, ["headerText"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["dataSource", "toolbar", "pageSettings", "locale", "searchSettings", "dataStateChange"])
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-close",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.close(_ctx.modalType.requestedModal)))
            }, [
              _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-times me-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("h4", _hoisted_56, _toDisplayString(_ctx.$t('jobRunStatus')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.close(_ctx.modalType.jobRunStatusModal)))
            }, [...(_cache[16] || (_cache[16] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('name')) + ":", 1),
                _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.jobRunStatus?.name), 1)
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('jobRunId')), 1),
                _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.jobRunStatus?.instanceId), 1)
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('runtimeStatus')), 1),
                _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.jobRunStatus?.runtimeStatus), 1)
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("hr", null, null, -1)),
              _cache[18] || (_cache[18] = _createElementVNode("h5", { class: "text-dark mb-3" }, "Input Details", -1)),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t('subscriptionId')), 1),
                _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.jobRunStatus.input?.subscriptionId), 1)
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t('partitionKey')), 1),
                _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.jobRunStatus.input?.partitionKey), 1)
              ]),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.$t('rowKey')), 1),
                _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.jobRunStatus.input?.rowKey), 1)
              ]),
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.$t('forceSync')), 1),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.jobRunStatus.input?.forceSync), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-close",
              "data-bs-dismiss": "modal",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.close(_ctx.modalType.jobRunStatusModal)))
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fas fa-times me-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}